import React from 'react';
import { useOtas } from '@travelity/api';
import { range } from 'lodash';
import { Box, Stack } from '@mui/material';
import { OtaCard } from './components/ota-card';
import { List, ListTitle } from '../../components/list-layout';

const OTAs = () => {
    const { data, isLoading } = useOtas();

    return (
        <List>
            <Box
                sx={{
                    // bgcolor: '#FFF',
                    flexGrow: 2,
                    mx: 2,
                    my: { xs: 0, sm: 2 },
                    px: 2,
                    height: { xs: '100%', sm: 'calc(100% - 32px)' },
                    minWidth: '320px',
                    overflow: isLoading ? 'hidden' : 'initial',
                }}
            >
                <ListTitle title="OTAs" />
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    gap={2}
                    py={2}
                >
                    {isLoading
                        ? range(1, 3).map(key => <OtaCard.Skeleton key={key} />)
                        : data?.map(ota => <OtaCard key={ota.id} ota={ota} />)}
                </Stack>
            </Box>
        </List>
    );
};

export default OTAs;
